import { useMemo } from "react";
import { useQueries } from "@tanstack/react-query";
import networkApi from "../api";
import { USEQUERY_DISABLE_REFETCH_OPTIONS } from "../consts";
import { chunkData } from "../util";
import { NetworkReputationBatch } from "../@types/Url";

const DEFAULT_QUERY_KEY_ID = "bulkNetworkReputation";
const NETWORK_REPUTATION_CHUNK_SIZE = 100;

type UseBulkNetworkReputationOptions = {
  queryKeyId?: string;
};

const useBulkNetworkReputation = (
  urls: string[],
  options?: UseBulkNetworkReputationOptions
) => {
  const chunkedData = useMemo(
    () => chunkData<string>(urls, NETWORK_REPUTATION_CHUNK_SIZE),
    [urls]
  );

  const result = useQueries({
    queries: chunkedData.map(chunk => ({
      queryKey: [options?.queryKeyId || DEFAULT_QUERY_KEY_ID, chunk],
      queryFn: () => networkApi.urlReputation(chunk).then(resp => resp.data),
      ...USEQUERY_DISABLE_REFETCH_OPTIONS
    }))
  });

  const batches = result.map<NetworkReputationBatch>((query, index) =>
    query.status === "success"
      ? { urls: chunkedData[index], status: "success", report: query.data }
      : { urls: chunkedData[index], status: query.status }
  );

  return {
    data: result.flatMap(res => res.data?.entries ?? []),
    batches,
    isLoading: result.some(query => query.isLoading)
  };
};

export default useBulkNetworkReputation;
